import React from "react";
import {RouteDescriptor} from "../../RouteDescriptor";
import {Route} from "../../Route";
import {groupAll} from "../../../roles/groups";
import {defineMessage} from "react-intl";

const HomeRouteTitleMessage = defineMessage({
  id: "homeRoute.title",
  defaultMessage: "Jetsnode",
})

export const home: RouteDescriptor<Route.home> = {
  route: Route.home,
  render: React.lazy(() => import("../../../../../pages/General/Home/HomePage").then(m => ({ default: m.HomePage }))),
  title: HomeRouteTitleMessage,
  path: '/',
  allowRoles: [
    ...groupAll,
  ],
  redirectToHomeRoles: [
  ],
  showInSidebar: false,
}